import { ENV_COUNTRY } from "../../components/Commons/Hooks/Variables/Enviroment";

const COUNTRY_MAP = {
	CL: 'Chile',
	CLNARMA: 'Chile',
	MX: 'México',
	AR: 'Argentina',
	CLANICX: 'Chile',
	CLGREEN: 'Chile',
	CLZUPHARMA: 'Chile',
};


const envCountryCode = ENV_COUNTRY || 'CL';

export const CURRENT_COUNTRY = COUNTRY_MAP[envCountryCode] || 'Chile';
